import { designSystemColors } from '@klv/shared/styles/colors';
import type { IGalleryCardTheme } from '../../types';

const galleryCard: IGalleryCardTheme = {
  hoverBorderColor: designSystemColors.lavenderShade,
};

export default galleryCard;
